// Persists an uploaded file's metadata via the case-files backend.
import { useCallback } from "react";

import { invalidateCaseFilesCache } from "../hooks/useCaseFiles";
import { useCaseService } from "../hooks/useCaseService";
import type { CaseFileResponse, CreateCaseFilePayload } from "../services/caseServiceV2";

interface SaveFileDetailsParams {
  file: File;
  bucketUrl: string;
  cloudFrontUrl: string;
  existingFileId?: string | null;
  caseId: string;
}

export const useFileDatabase = () => {
  const caseService = useCaseService();

  const saveFileDetails = useCallback(
    async ({
      file,
      bucketUrl,
      cloudFrontUrl,
      existingFileId = null,
      caseId,
    }: SaveFileDetailsParams): Promise<CaseFileResponse> => {
      const payload: CreateCaseFilePayload = {
        filename: file.name,
        bucket_url: bucketUrl,
        cloudfront_url: cloudFrontUrl,
        file_size: file.size,
        mime_type: file.type,
        existing_file_id: existingFileId,
      };
      const fileData = await caseService.createCaseFile(caseId, payload);

      invalidateCaseFilesCache(caseId);

      return fileData;
    },
    [caseService]
  );

  return {
    saveFileDetails,
  };
};
